import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import SpaceOverviewGroupedButtonsQuery from './__generated__/SpaceOverviewGroupedButtonsQuery.graphql';
import type {
	SpaceOverviewGroupedButtonsQuery$data,
	SpaceOverviewGroupedButtonsQuery$variables,
} from './__generated__/SpaceOverviewGroupedButtonsQuery.graphql';

export function preloadSpaceStarTextButton(spaceKey: string) {
	return query<SpaceOverviewGroupedButtonsQuery$data, SpaceOverviewGroupedButtonsQuery$variables>({
		query: SpaceOverviewGroupedButtonsQuery,
		variables: {
			spaceKey,
		},
	});
}
